// extracted by mini-css-extract-plugin
export default {"textOverImg":"photoArchive_textOverImg__+vNsT","object__select":"photoArchive_object__select__jLyWe","download__cont":"photoArchive_download__cont__cwcki"};